import Vue from 'vue'

export default (ctx) => {
    // Create a reactive state
    const state = Vue.observable({
        quotes: {},
    })

    const clearQuotes = function () {
        state.quotes = {}
    }

    // Set a sku/quote pair for Add To Cart
    // if quoteId is null it will remove it
    const setQuote = function (sku, quoteId) {
        // We will recreate the Quotes object each time
        const { [sku]: id, ...quotes } = state.quotes

        // We are adding the changed/new record if it exists
        state.quotes = {
            ...quotes,
            ...(quoteId && { [sku]: quoteId }),
        }
    }

    // Add To Cart will need to fetch a quote by sku
    const getQuoteIdBySku = function (sku) {
        return state.quotes[sku]
    }

    const addInstallation = async function (itemId, quoteId, city, state) {
        // Add to a Line Item
        try {
            await ctx.$axios.post(
                `${ctx.$config.platform.apis.cart}${ctx.store.state.permId}/items/${itemId}/installation`,
                {
                    quoteId,
                    city,
                    state,
                },
                {
                    headers: {
                        'x-site': ctx.$sitewideData.sitePrefix,
                    },
                }
            )

            await ctx.store.dispatch('cart/getCart')
        } catch (err) {
            throw err.response.data
        }
    }

    const removeInstallation = async function (itemId) {
        // Add to a Line Item
        try {
            await ctx.$axios.delete(
                `${ctx.$config.platform.apis.cart}${ctx.store.state.permId}/items/${itemId}/installation`,
                {
                    headers: {
                        'x-site': ctx.$sitewideData.sitePrefix,
                    },
                }
            )

            await ctx.store.dispatch('cart/getCart')
        } catch (err) {
            throw err.response.data
        }
    }

    const updateInstallation = async function (itemId, city, state, zip) {
        // Add to a Line Item
        try {
            await ctx.$axios.put(
                `${ctx.$config.platform.apis.cart}${ctx.store.state.permId}/items/${itemId}/installation`,
                {
                    city,
                    state,
                    zip,
                },
                {
                    headers: {
                        'x-site': ctx.$sitewideData.sitePrefix,
                    },
                }
            )

            await ctx.store.dispatch('cart/getCart')
        } catch (err) {
            throw err.response.data
        }
    }

    return {
        setQuote,
        getQuoteIdBySku,
        addInstallation,
        removeInstallation,
        updateInstallation,
        clearQuotes,
        state,
    }
}
